import React, { ReactElement } from 'react';

export const TextLimit = ({ text, limit = 80 }: { text: string; limit?: number }): ReactElement => {
  const limitedText = text.length > limit ? `${text.slice(0, limit)}...` : text;
  return <div className="py-2">{limitedText}</div>;
};
